import { render, staticRenderFns } from "./msElegList.vue?vue&type=template&id=884754b8&scoped=true"
import script from "./msElegList.vue?vue&type=script&lang=js"
export * from "./msElegList.vue?vue&type=script&lang=js"
import style0 from "./msElegList.vue?vue&type=style&index=0&id=884754b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884754b8",
  null
  
)

export default component.exports